import {Button} from "@/components/ui/button";
import {useNavigate} from "react-router-dom";
import {ArrowRightIcon, HomeIcon, RefreshCwIcon} from "lucide-react";
import {motion} from "framer-motion";

export default function Page404() {
    const navigate = useNavigate();

    return (
        <div className="w-full flex flex-col items-center justify-center bg-background">
            <div className="max-w-md w-full px-4 py-8 text-center space-y-6">
                {/* 404 Number */}
                <h1 className="text-9xl font-extrabold tracking-tighter text-primary">
                    <span className="sr-only">خطا</span>
                    <motion.div animate={{opacity: [1, 0.5, 1, 0.6, 1, 0.4, 1]}}
                                transition={{repeat: Infinity, duration: 5}}>
                        <div>404</div>
                    </motion.div>
                </h1>

                {/* Illustration */}
                <div className="relative mx-auto w-16 h-16">
                    <div className="absolute inset-0 bg-muted rounded-full opacity-20 animate-pulse"></div>
                    <div className="absolute inset-4 bg-muted/50 rounded-full"></div>
                    <div className="absolute inset-0 flex items-center justify-center">
                        <svg
                            className="w-24 h-24 text-muted-foreground"
                            fill="none"
                            height="24"
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            viewBox="0 0 24 24"
                            width="24"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <circle cx="12" cy="12" r="10"/>
                            <path d="m15 9-6 6"/>
                            <path d="m9 9 6 6"/>
                        </svg>
                    </div>
                </div>

                {/* Message */}
                <div className="space-y-2">
                    <h2 className="text-2xl font-bold tracking-tight text-foreground">صفحه مورد نظر یافت نشد</h2>
                    <p className="text-muted-foreground">
                        با عرض پوزش ، ما نتوانستیم صفحه مورد نظر خود را پیدا کنیم. این ممکن است جابجا شده ، حذف شده یا
                        هرگز وجود نداشته باشد.
                    </p>
                </div>

                {/* Actions */}
                <div className="flex flex-col sm:flex-row gap-2 justify-center mt-8">
                    <Button
                        variant="outline"
                        onClick={() => navigate(-1)}
                        className="gap-2"
                    >
                        <ArrowRightIcon className="h-4 w-4"/>
                        بازگشت
                    </Button>

                    <Button
                        variant="ghost"
                        onClick={() => window.location.reload()}
                        className="gap-2"
                    >
                        <RefreshCwIcon className="h-4 w-4"/>
                        بررسی مجدد
                    </Button>
                    <Button
                        variant="default"
                        onClick={() => navigate('/')}
                        className="gap-2"
                    >
                        <HomeIcon className="h-4 w-4"/>
                        صفحه خانه
                    </Button>

                </div>
            </div>
        </div>
    );
}